<mat-spinner [diameter]="diameterPreset" />
